import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useSearchParams} from "react-router-dom";
import frameDefault from "../img/thumb/frame-100x60.png";
import defaultImage from "../img/default.jpg";
import Pagination from "react-js-pagination";

export default function News(prop) {
    let [searchParams] = useSearchParams();

    let [data, setData] = React.useState(null);
    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [newsCategory, setNewsCategory] = React.useState(null);
    let [newsCategoryId, setNewsCategoryId] = React.useState(null);

    React.useEffect(() => {
        let title = (prop.lang === 'en' ? 'News':'ข่าว') + ' | NCSA';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        if(searchParams.get('category')) {
            setNewsCategoryId(searchParams.get('category'));
        }

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const newsCategoryListing = await getNewsCategory();
                setNewsCategory(newsCategoryListing);

                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }
            } catch (e) {
                //
            }
        })();
    }, [searchParams]);

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'/newsCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getView() {
        const response = await fetch(Config.apiUrl +'/newsBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let newsCategoryId = null;
        if(searchParams.get('category')) {
            newsCategoryId = searchParams.get('category');
        }

        const response = await fetch(Config.apiUrl +'/news/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                categoryId: newsCategoryId,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'news_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'News':'ข่าวสาร'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'News':'ข่าวสาร'} </p>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <ul className="nav nav-links nav-color-custom pt-0">
                        <li><a href={prop.lang === 'en' ? '/en/news':'/news'} className={newsCategoryId == null ? 'active' : ''}><span
                            className="line-animate">{prop.lang === 'en' ? 'News​ All':'ข่าวทั้งหมด'}</span></a></li>
                        {
                            newsCategory !== null && newsCategory.count > 0 ?
                                newsCategory.rows.map((row, index) => {
                                    return (
                                        <li key={index}>
                                            <a href={prop.lang === 'en' ? '/en/news':'/news?category=' + row.id} className={newsCategoryId !== null && parseInt(newsCategoryId) === parseInt(row.id) ? 'active':''}>
                                                <span className="line-animate">{prop.lang === 'en' ? row.title_en:row.title}</span>
                                            </a>
                                        </li>
                                    )
                                }) : ''
                        }
                    </ul>
                    {
                        listing !== null && listing.count > 0 ?
                        <>
                            <div className="row card-news-lists">
                                {
                                    listing.rows.map((row, index) => {
                                        return (
                                            <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                                                <div className="card-news bg-none" data-aos="fade-in">
                                                    <NavLink to={(prop.lang === 'en' ? '/en':'') + '/news/detail/' + row.slug} className="card-link"></NavLink>
                                                    <div className="card-photo">
                                                        <div className="photo"
                                                             style={{backgroundImage: 'url("' + (row?.image !== null ? Config.fileUpload + 'news/' + row?.image : defaultImage) + '")'}}>
                                                            <img src={frameDefault} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <h3>{prop.lang === 'en' ? row.title_en:row.title}</h3>
                                                        <p>{Utils.dateDMY(row.createdAt, prop.lang)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className={totalPage > 1 ? '':'d-none'}>
                                <Pagination
                                    itemClassPrev="arrow prev"
                                    itemClassNext="arrow next"
                                    activeClass="active"
                                    itemClass=""
                                    linkClass=""
                                    innerClass="pagination"
                                    activePage={activePage}
                                    itemsCountPerPage={itemPerpage}
                                    totalItemsCount={countAllItem}
                                    pageRangeDisplayed={5}
                                    onChange={(pageNum) => onPageChange(pageNum)}
                                />
                            </div>

                        </> : <p>{prop.lang === 'en' ? 'Not found':'ไม่พบข้อมูล'}</p>

                    }
                </div>
            </div>
        </>
    );
} 